import React, { useState } from "react";
import { FaCheckCircle, FaExclamationTriangle } from "react-icons/fa";
import { useNotify } from "../../components/ConfirmModal";
import { errorMessage } from "./workApi";

const OK_STATUSES = ["tracked", "already_tracked"];

/**
 * Whether a hand-made post is tracked (numbers + comments sync) and a field to paste / fix its live link.
 * ``onTrack(url)`` calls the track endpoint and resolves to {status, message}.
 */
function TrackingBox({ tracking, postedUrl, onTrack, onChanged }) {
  const notify = useNotify();
  const [url, setUrl] = useState(postedUrl || "");
  const [busy, setBusy] = useState(false);
  const [state, setState] = useState(tracking);
  const status = state?.status;
  const tracked = OK_STATUSES.includes(status);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const res = await onTrack(url.trim() || null);
      setState({ status: res.status, message: res.message });
      (OK_STATUSES.includes(res.status) ? notify.success : notify.error)(res.message || "Done");
      onChanged?.();
    } catch (err) {
      notify.error(errorMessage(err, "Could not check the link"));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className={`wk-banner${tracked ? " wk-banner--ok" : ""}`} style={{ display: "block" }}>
      {tracked ? (
        <span>
          <FaCheckCircle aria-hidden="true" /> Tracking this post. Its numbers and comments sync every hour.
        </span>
      ) : (
        <>
          <strong>
            <FaExclamationTriangle aria-hidden="true" /> Results are not being tracked yet.
          </strong>
          <div style={{ fontSize: 13, marginTop: 4 }}>
            {state?.message || "Paste the live post link so Cloud Office can find the post and sync its numbers."}
          </div>
        </>
      )}
      {!tracked ? (
        <form className="wk-quick-add" onSubmit={submit} style={{ marginTop: 8 }}>
          <label className="wk-sr-only" htmlFor="track-url">
            Live post link
          </label>
          <input
            id="track-url"
            type="url"
            value={url}
            onChange={(e) => setUrl(e.target.value)}
            placeholder="https://www.instagram.com/p/…"
          />
          <button type="submit" className="dmp-btn" disabled={busy}>
            {busy ? "Checking…" : "Find post"}
          </button>
        </form>
      ) : null}
    </div>
  );
}

export default TrackingBox;
